import React from 'react';

/**
 * A simple modal component to display a large version of an image.
 * It closes when the user clicks on the dark overlay.
 * @param {object} props
 * @param {boolean} props.isOpen - Whether the modal should be visible.
 * @param {function(): void} props.onClose - The function to call to close the modal.
 * @param {string} props.imageUrl - The URL of the image to display.
 */
export default function ImageModal({ isOpen, onClose, imageUrl }) {
    if (!isOpen) {
        return null;
    }

    return (
        // The dark overlay. Clicking it will close the modal.
        <div 
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
            onClick={onClose}
        >
            {/* The main image container */}
            <div className="relative" onClick={(e) => e.stopPropagation()}>
                <img
                    src={imageUrl}
                    alt="Enlarged offer view"
                    className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-xl"
                />
                {/* A simple close button in the corner */}
                <button 
                    onClick={onClose}
                    className="absolute -top-4 -right-4 bg-white text-black rounded-full h-8 w-8 flex items-center justify-center font-bold text-lg"
                >
                    &times;
                </button>
            </div>
        </div>
    );
}